/* AMBESA · IMMERSIVE · motion and interaction engine. No libraries.
   Curtain intro and page transitions, word reveals, scroll scenes, pinned horizontal track,
   velocity marquee, hero slideshow, card image scrub, quick add, instant filters,
   hover previews, drag strips, label cursor and magnetic buttons. */
(() => {
  'use strict';
  const d = document;
  const h = d.documentElement;
  const w = window;
  const mm = (q) => !!(w.matchMedia && w.matchMedia(q).matches);
  const reduce = mm('(prefers-reduced-motion: reduce)');
  const fine = mm('(hover: hover) and (pointer: fine)');
  const design = !!(w.Shopify && w.Shopify.designMode);
  const $$ = (s, r) => Array.prototype.slice.call((r || d).querySelectorAll(s));
  const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
  const lerp = (a, b, t) => a + (b - a) * t;
  const raf = (f) => w.requestAnimationFrame(f);
  const IO = 'IntersectionObserver' in w;
  let store = null;
  try { store = w.sessionStorage; } catch (e) { store = null; }
  const ssSet = (k, v) => { try { if (store) store.setItem(k, v); } catch (e) { /* private mode */ } };
  const ssDel = (k) => { try { if (store) store.removeItem(k); } catch (e) { /* private mode */ } };
  const pad2 = (n) => (n < 10 ? '0' : '') + n;
  let vw = w.innerWidth;
  let vh = w.innerHeight;
  const isDesk = () => vw >= 990;

  /* things that wait for the curtain to lift */
  const shownQ = [];
  let shown = !h.classList.contains('amx-cover');
  if (shown) h.classList.add('amx-shown');
  const onShown = (fn) => { if (shown) fn(); else shownQ.push(fn); };
  const markShown = () => {
    if (shown) return;
    shown = true;
    h.classList.add('amx-shown');
    shownQ.splice(0).forEach((fn) => fn());
  };

  /* curtain: first visit intro, arrival after a page transition */
  const curtain = d.getElementById('amx-curtain');
  const lift = () => {
    if (!h.classList.contains('amx-cover')) { markShown(); return; }
    const go = () => {
      h.classList.add('amx-reveal');
      setTimeout(markShown, 160);
      setTimeout(() => h.classList.remove('amx-cover', 'amx-intro', 'amx-arrive', 'amx-reveal'), 1000);
    };
    if (!h.classList.contains('amx-intro') || !curtain) { raf(() => raf(go)); return; }
    const count = curtain.querySelector('[data-amx-count]');
    const bar = curtain.querySelector('.amx-curtain__line span');
    const heroImg = d.querySelector('.amx-hero__frame.is-active img');
    const t0 = performance.now();
    const dur = 1250;
    const finish = () => {
      if (!heroImg || heroImg.complete) { setTimeout(go, 150); return; }
      let done = false;
      const once = () => { if (done) return; done = true; go(); };
      heroImg.addEventListener('load', once, { once: true });
      heroImg.addEventListener('error', once, { once: true });
      setTimeout(once, 900);
    };
    const tick = (t) => {
      const p = clamp((t - t0) / dur, 0, 1);
      const e = 1 - Math.pow(1 - p, 3);
      if (count) count.textContent = pad2(Math.round(e * 100));
      if (bar) bar.style.transform = 'scaleX(' + e.toFixed(3) + ')';
      if (p < 1) raf(tick); else finish();
    };
    raf(tick);
  };

  /* page transitions between internal pages */
  let leaving = false;
  const skipPath = new RegExp('^/(?:[a-z]{2}(?:-[a-z]{2})?/)?(?:cart|checkouts?|account|apps|services|tools|admin|password)(?:/|$)', 'i');
  const transitionUrl = (a, e) => {
    if (reduce || design || leaving || !a) return null;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return null;
    if ((a.target && a.target !== '_self') || a.hasAttribute('download') || a.closest('[data-amx-no-transition]')) return null;
    const raw = a.getAttribute('href') || '';
    if (!raw || raw.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(raw)) return null;
    let url;
    try { url = new URL(a.href, w.location.href); } catch (err) { return null; }
    if (url.origin !== w.location.origin || skipPath.test(url.pathname)) return null;
    if (url.pathname === w.location.pathname && url.search === w.location.search) return null;
    return url;
  };
  const leave = (href) => {
    if (reduce || design) { w.location.assign(href); return; }
    leaving = true;
    ssSet('amx-nav', '1');
    h.classList.add('amx-leave');
    raf(() => raf(() => h.classList.add('amx-leave-go')));
    setTimeout(() => w.location.assign(href), 640);
    setTimeout(() => { leaving = false; h.classList.remove('amx-leave', 'amx-leave-go'); ssDel('amx-nav'); }, 6000);
  };
  d.addEventListener('click', (e) => {
    const t = e.target;
    const a = t && t.closest ? t.closest('a[href]') : null;
    const url = transitionUrl(a, e);
    if (!url) return;
    e.preventDefault();
    leave(url.href);
  });
  w.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    leaving = false;
    h.classList.remove('amx-leave', 'amx-leave-go', 'amx-cover', 'amx-intro', 'amx-arrive', 'amx-reveal');
    markShown();
  });
  const warmed = new Set();
  d.addEventListener('pointerover', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || warmed.size > 30) return;
    let url;
    try { url = new URL(a.href, w.location.href); } catch (err) { return; }
    const key = url.pathname + url.search;
    if (url.origin !== w.location.origin || skipPath.test(url.pathname) || warmed.has(key) || url.pathname === w.location.pathname) return;
    warmed.add(key);
    const l = d.createElement('link');
    l.rel = 'prefetch';
    l.href = url.href;
    d.head.appendChild(l);
  }, { passive: true });

  /* word split + reveal */
  const split = (el) => {
    if (el.__amxSplit) return;
    el.__amxSplit = true;
    const walker = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    let i = 0;
    nodes.forEach((node) => {
      const text = node.nodeValue;
      if (!text || !text.trim()) return;
      const frag = d.createDocumentFragment();
      text.split(/(\s+)/).forEach((part) => {
        if (!part) return;
        if (!part.trim()) { frag.appendChild(d.createTextNode(' ')); return; }
        const o = d.createElement('span');
        o.className = 'amx-w';
        const inner = d.createElement('span');
        inner.className = 'amx-w__i';
        inner.textContent = part;
        inner.style.setProperty('--wi', String(i));
        i += 1;
        o.appendChild(inner);
        frag.appendChild(o);
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.style.setProperty('--wn', String(Math.max(1, i)));
    el.classList.add('amx-split-done');
  };
  const revealIO = IO ? new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target;
      revealIO.unobserve(el);
      onShown(() => el.classList.add('is-in'));
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }) : null;
  const initReveal = (root) => {
    $$('[data-amx-split]', root).forEach(split);
    $$('[data-amx-reveal], [data-amx-split]', root).forEach((el) => {
      if (el.__amxRev) return;
      el.__amxRev = true;
      if (!revealIO || reduce) { el.classList.add('is-in'); return; }
      revealIO.observe(el);
    });
  };

  /* scroll scenes: every [data-amx-scene] gets --p from 0 to 1 */
  const scenes = [];
  const hscrolls = [];
  const addScene = (el, cb) => {
    el.__amxScene = true;
    const s = { el, mode: el.getAttribute('data-amx-scene') || 'view', top: 0, height: 0, cur: -1, cb: cb || null };
    scenes.push(s);
    return s;
  };
  const sizeH = (hs) => {
    if (!isDesk() || reduce) { hs.el.style.height = ''; hs.track.style.transform = ''; hs.dist = 0; return; }
    hs.dist = Math.max(0, hs.track.scrollWidth - vw);
    hs.el.style.height = Math.round(hs.dist + vh) + 'px';
  };
  const measure = () => {
    vw = w.innerWidth;
    vh = w.innerHeight;
    hscrolls.forEach(sizeH);
    const y = w.scrollY;
    for (let i = scenes.length - 1; i >= 0; i -= 1) {
      const s = scenes[i];
      if (!s.el.isConnected) { scenes.splice(i, 1); continue; }
      const r = s.el.getBoundingClientRect();
      s.top = r.top + y;
      s.height = r.height;
    }
  };
  const progressOf = (s, y) => {
    if (s.mode === 'pin') return clamp((y - s.top) / Math.max(1, s.height - vh), 0, 1);
    if (s.mode === 'exit') return clamp((y - s.top) / Math.max(1, s.height), 0, 1);
    return clamp((y + vh - s.top) / Math.max(1, s.height + vh), 0, 1);
  };
  let ticking = false;
  let lastY = w.scrollY;
  let velocity = 0;
  const frame = () => {
    ticking = false;
    const y = w.scrollY;
    velocity = lerp(velocity, y - lastY, 0.3);
    lastY = y;
    let again = Math.abs(velocity) > 0.05;
    for (let i = 0; i < scenes.length; i += 1) {
      const s = scenes[i];
      const t = progressOf(s, y);
      const next = s.cur < 0 || reduce ? t : lerp(s.cur, t, 0.18);
      if (Math.abs(t - next) > 0.0008) again = true;
      if (Math.abs(next - s.cur) > 0.0002) {
        s.cur = next;
        s.el.style.setProperty('--p', next.toFixed(4));
        if (s.cb) s.cb(next);
      }
    }
    if (again) kick();
  };
  const kick = () => { if (!ticking) { ticking = true; raf(frame); } };
  w.addEventListener('scroll', kick, { passive: true });
  const initScenes = (root) => {
    $$('[data-amx-scene]', root).forEach((el) => { if (!el.__amxScene) addScene(el); });
  };

  /* pinned horizontal track */
  const initHScroll = (root) => {
    $$('[data-amx-hscroll]', root).forEach((el) => {
      if (el.__amxScene) return;
      const track = el.querySelector('[data-amx-hscroll-track]');
      if (!track) return;
      const hs = { el, track, dist: 0 };
      hscrolls.push(hs);
      el.setAttribute('data-amx-scene', 'pin');
      addScene(el, (p) => { if (hs.dist) track.style.transform = 'translate3d(' + (-p * hs.dist).toFixed(1) + 'px,0,0)'; });
    });
  };

  /* marquee that speeds up and turns with your scroll */
  const marquees = [];
  let mqOn = false;
  const runMarquees = () => {
    if (mqOn || reduce || !marquees.length) return;
    mqOn = true;
    let last = performance.now();
    const loop = (t) => {
      const dt = Math.min(64, t - last) / 1000;
      last = t;
      let any = false;
      const dirMul = velocity < -0.6 ? -1 : 1;
      const boost = 1 + Math.min(5, Math.abs(velocity) * 0.22);
      marquees.forEach((m) => {
        if (!m.on || !m.w) return;
        any = true;
        m.x += m.dir * dirMul * m.base * boost * (m.hover ? 0.3 : 1) * dt;
        if (m.x <= -m.w) m.x += m.w;
        if (m.x > 0) m.x -= m.w;
        m.track.style.transform = 'translate3d(' + m.x.toFixed(2) + 'px,0,0)';
      });
      if (any) raf(loop); else mqOn = false;
    };
    raf(loop);
  };
  const initMarquee = (root) => {
    $$('[data-amx-marquee]', root).forEach((el) => {
      if (el.__amxM) return;
      el.__amxM = true;
      const track = el.querySelector('.amx-mq__track');
      const group = el.querySelector('.amx-mq__group');
      if (!track || !group) return;
      const m = { el, track, group, x: 0, w: 0, base: Number(el.getAttribute('data-speed') || 60), dir: el.getAttribute('data-dir') === 'right' ? 1 : -1, on: !IO, hover: false };
      const fill = () => {
        m.w = group.getBoundingClientRect().width;
        if (!m.w) return;
        const need = Math.max(2, Math.ceil((w.innerWidth * 2) / m.w) + 1);
        while (track.children.length < need) {
          const c = group.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          $$('a, button', c).forEach((x) => x.setAttribute('tabindex', '-1'));
          track.appendChild(c);
        }
      };
      fill();
      if ('ResizeObserver' in w) new ResizeObserver(fill).observe(group);
      el.addEventListener('pointerenter', () => { m.hover = true; });
      el.addEventListener('pointerleave', () => { m.hover = false; });
      if (IO) new IntersectionObserver((en) => { m.on = en[0].isIntersecting; if (m.on) runMarquees(); }).observe(el);
      marquees.push(m);
    });
    runMarquees();
  };

  /* hero slideshow with wipe, ken burns and pointer parallax */
  const initHero = (root) => {
    $$('[data-amx-hero]', root).forEach((hero) => {
      if (hero.__amxScene) return;
      addScene(hero);
      const frames = $$('[data-amx-frame]', hero);
      const caps = $$('[data-amx-cap]', hero);
      const dots = $$('[data-amx-dot]', hero);
      const n = frames.length;
      const dur = Number(hero.getAttribute('data-interval')) || 6000;
      hero.style.setProperty('--amx-dur', dur + 'ms');
      let i = 0;
      let timer = 0;
      let visible = true;
      const restartDot = () => {
        dots.forEach((b, j) => { b.classList.remove('is-active'); b.classList.toggle('is-done', j < i); b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        const dot = dots[i];
        if (dot) { void dot.offsetWidth; dot.classList.add('is-active'); }
      };
      const paint = (k) => {
        if (!n) return;
        const next = ((k % n) + n) % n;
        if (next === i) { restartDot(); return; }
        const prev = i;
        i = next;
        frames.forEach((f, j) => {
          f.classList.toggle('is-prev', j === prev);
          f.classList.toggle('is-active', j === i);
          if (j === i) { const img = f.querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; }
        });
        caps.forEach((c, j) => c.classList.toggle('is-active', j === i));
        restartDot();
      };
      const stop = () => { if (timer) { clearInterval(timer); timer = 0; } };
      const start = () => { stop(); if (!reduce && n > 1 && visible && !d.hidden) timer = setInterval(() => paint(i + 1), dur); };
      dots.forEach((b, j) => b.addEventListener('click', () => { paint(j); start(); }));
      onShown(() => {
        setTimeout(() => hero.classList.add('is-on'), 40);
        restartDot();
        start();
      });
      if (IO) new IntersectionObserver((en) => {
        visible = en[0].isIntersecting;
        hero.classList.toggle('is-paused', !visible);
        if (visible && shown) { restartDot(); start(); } else stop();
      }, { threshold: 0.2 }).observe(hero);
      d.addEventListener('visibilitychange', () => { if (d.hidden) stop(); else if (visible && shown) { restartDot(); start(); } });
      if (fine && !reduce) {
        hero.addEventListener('pointermove', (e) => {
          const r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
          hero.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
        });
      }
    });
  };

  /* product cards: image scrub on desktop, swipe on phones, size sheet */
  const hydrate = (img) => {
    const src = img.getAttribute('data-amx-src');
    if (!src) return;
    const set = img.getAttribute('data-amx-srcset');
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', src);
    img.removeAttribute('data-amx-src');
  };
  const initCards = (root) => {
    $$('[data-amx-card]', root).forEach((card) => {
      if (card.__amxCard) return;
      card.__amxCard = true;
      const media = card.querySelector('.amx-card__media');
      const track = card.querySelector('[data-amx-track]');
      const imgs = track ? $$('.amx-card__img', track) : [];
      const dots = $$('.amx-card__dots i', card);
      const setDot = (k) => dots.forEach((x, j) => x.classList.toggle('is-active', j === k));
      let woke = false;
      const wake = () => { if (woke) return; woke = true; imgs.forEach(hydrate); };
      if (media && imgs.length > 1) {
        let cur = 0;
        const show = (k) => {
          if (k === cur) return;
          cur = k;
          track.classList.add('has-active');
          imgs.forEach((im, j) => im.classList.toggle('is-active', j === k));
          setDot(k);
        };
        media.addEventListener('pointerenter', wake);
        media.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse' || !isDesk()) return;
          const r = media.getBoundingClientRect();
          show(clamp(Math.floor(((e.clientX - r.left) / r.width) * imgs.length), 0, imgs.length - 1));
        });
        media.addEventListener('pointerleave', () => show(0));
        track.addEventListener('touchstart', wake, { passive: true });
        track.addEventListener('scroll', () => { wake(); setDot(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, { passive: true });
      }
      const plus = card.querySelector('[data-amx-quick-toggle]');
      if (plus) plus.addEventListener('click', (e) => {
        e.preventDefault();
        const on = !card.classList.contains('is-quick');
        $$('.amx-card.is-quick').forEach((c) => { if (c !== card) c.classList.remove('is-quick'); });
        card.classList.toggle('is-quick', on);
        plus.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
  };

  /* quick add: one tap on a size puts it in the bag and opens the drawer */
  let CartAddEvent = null;
  const eventsReady = import('@theme/events').then((m) => { CartAddEvent = m.CartAddEvent; }).catch(() => {});
  let toastTimer = 0;
  const toast = (msg, bad) => {
    const el = d.querySelector('.amx-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!bad);
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 3400);
  };
  d.addEventListener('click', async (e) => {
    const b = e.target && e.target.closest ? e.target.closest('[data-amx-add]') : null;
    if (!b || b.disabled || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    const id = Number(b.getAttribute('data-amx-add'));
    const prop = b.getAttribute('data-amx-prop');
    const item = { id, quantity: 1 };
    if (prop) item.properties = { Preorder: prop };
    const sections = Array.from(new Set($$('cart-items-component[data-section-id]').map((el) => el.getAttribute('data-section-id'))));
    b.setAttribute('aria-busy', 'true');
    b.classList.add('is-busy');
    try {
      const root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item], sections: sections.join(','), sections_url: w.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || '');
      await eventsReady;
      b.classList.add('is-added');
      setTimeout(() => b.classList.remove('is-added'), 1600);
      const card = b.closest('.amx-card');
      if (card) card.classList.remove('is-quick');
      if (CartAddEvent) {
        d.dispatchEvent(new CartAddEvent({}, 'amx-quick-add', { source: 'product-form-component', itemCount: 1, variantId: String(id), productId: b.getAttribute('data-product-id'), sections: data.sections }));
      } else {
        w.location.assign(root + 'cart');
      }
    } catch (err) {
      toast((err && err.message) || 'This size could not be added. Please try another one.', true);
    } finally {
      b.removeAttribute('aria-busy');
      b.classList.remove('is-busy');
    }
  });

  /* instant filters on grids */
  const applyFilters = (scope) => {
    const active = $$('[data-amx-filter].is-active', scope).map((c) => c.getAttribute('data-amx-filter')).filter((f) => f && f !== '*');
    const cards = $$('[data-amx-card]', scope);
    const run = () => {
      let count = 0;
      cards.forEach((c) => {
        const ok = active.every((f) => {
          const cut = f.indexOf(':');
          const k = f.slice(0, cut);
          const v = f.slice(cut + 1);
          if (k === 'size') return (',' + (c.getAttribute('data-sizes') || '') + ',').indexOf(',' + v + ',') > -1;
          return (c.getAttribute('data-' + k) || '') === v;
        });
        c.hidden = !ok;
        if (ok) count += 1;
      });
      $$('[data-amx-count-shown]', scope).forEach((x) => { x.textContent = String(count); });
      const empty = scope.querySelector('[data-amx-empty]');
      if (empty) empty.hidden = count > 0;
      measure();
      kick();
    };
    if (d.startViewTransition && !reduce && cards.length < 80) {
      cards.forEach((c, j) => { c.style.viewTransitionName = 'amx-c' + j; });
      const t = d.startViewTransition(run);
      t.finished.finally(() => cards.forEach((c) => { c.style.viewTransitionName = ''; }));
    } else run();
  };
  d.addEventListener('click', (e) => {
    const chip = e.target && e.target.closest ? e.target.closest('[data-amx-filter]') : null;
    if (!chip) return;
    const scope = chip.closest('[data-amx-filters-scope]');
    if (!scope) return;
    e.preventDefault();
    const group = chip.getAttribute('data-amx-group') || 'main';
    const wasActive = chip.classList.contains('is-active');
    const toggle = chip.hasAttribute('data-amx-toggle');
    $$('[data-amx-filter]', scope).forEach((c) => {
      if ((c.getAttribute('data-amx-group') || 'main') !== group) return;
      const on = c === chip ? (toggle ? !wasActive : true) : false;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    applyFilters(scope);
  });
  d.addEventListener('change', (e) => {
    const sel = e.target && e.target.closest ? e.target.closest('[data-amx-sort]') : null;
    if (!sel) return;
    const url = new URL(w.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    leave(url.href);
  });
  d.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest ? e.target.closest('[data-amx-rail-go]') : null;
    if (!btn) return;
    const sec = btn.closest('section');
    const strip = sec ? sec.querySelector('[data-amx-rail]') : null;
    if (!strip) return;
    const dir = Number(btn.getAttribute('data-amx-rail-go')) || 1;
    strip.scrollBy({ left: dir * Math.max(260, strip.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' });
  });

  /* floating preview that follows the pointer over the country list */
  const initPreview = (root) => {
    if (!fine || reduce) return;
    $$('[data-amx-preview-list]', root).forEach((list) => {
      if (list.__amxPv) return;
      list.__amxPv = true;
      const pv = list.querySelector('[data-amx-preview]');
      const img = pv ? pv.querySelector('img') : null;
      if (!pv || !img) return;
      let tx = 0;
      let ty = 0;
      let x = 0;
      let y = 0;
      let on = false;
      let running = false;
      let first = true;
      let warm = false;
      const loop = () => {
        const nx = lerp(x, tx, 0.17);
        const ny = lerp(y, ty, 0.17);
        const vx = nx - x;
        x = nx;
        y = ny;
        pv.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) translate(-50%,-50%) rotate(' + clamp(vx * 0.5, -10, 10).toFixed(2) + 'deg)';
        if (Math.abs(tx - x) > 0.4 || Math.abs(ty - y) > 0.4) raf(loop); else running = false;
      };
      const go = () => { if (!running) { running = true; raf(loop); } };
      const show = (row) => {
        if (!warm) {
          warm = true;
          $$('[data-amx-preview-src]', list).forEach((r) => { const im = new Image(); im.src = r.getAttribute('data-amx-preview-src'); });
        }
        const src = row.getAttribute('data-amx-preview-src');
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
        on = true;
        pv.classList.add('is-on');
        go();
      };
      const hide = () => { on = false; pv.classList.remove('is-on'); };
      list.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        tx = e.clientX;
        ty = e.clientY;
        if (first) { x = tx; y = ty; first = false; }
        const row = e.target && e.target.closest ? e.target.closest('[data-amx-preview-src]') : null;
        if (row && (!on || img.getAttribute('src') !== row.getAttribute('data-amx-preview-src'))) show(row);
        if (!row && on) hide();
        go();
      });
      list.addEventListener('pointerleave', hide);
      w.addEventListener('scroll', () => { if (on) hide(); }, { passive: true });
    });
  };

  /* craft: the camera moves to the detail you are reading */
  const initCraft = (root) => {
    $$('[data-amx-craft]', root).forEach((sec) => {
      if (sec.__amxCraft) return;
      sec.__amxCraft = true;
      const frameEl = sec.querySelector('[data-amx-craft-frame]');
      const specs = $$('[data-amx-spec]', sec);
      if (!frameEl || !specs.length) return;
      const apply = (s) => {
        specs.forEach((x) => x.classList.toggle('is-active', x === s));
        frameEl.style.setProperty('--z', s.getAttribute('data-z') || '1');
        frameEl.style.setProperty('--x', (s.getAttribute('data-x') || '50') + '%');
        frameEl.style.setProperty('--y', (s.getAttribute('data-y') || '50') + '%');
      };
      if (!IO || reduce) { specs.forEach((x) => x.classList.add('is-active')); return; }
      const band = isDesk() ? '-45% 0px -45% 0px' : '-62% 0px -28% 0px';
      const ob = new IntersectionObserver((en) => { en.forEach((x) => { if (x.isIntersecting) apply(x.target); }); }, { rootMargin: band, threshold: 0 });
      specs.forEach((s) => ob.observe(s));
      apply(specs[0]);
    });
  };

  /* drag to scroll strips with a little inertia (mouse only, touch scrolls natively) */
  const initDrag = (root) => {
    $$('[data-amx-drag]', root).forEach((el) => {
      if (el.__amxDrag) return;
      el.__amxDrag = true;
      let down = false;
      let moved = false;
      let sx = 0;
      let sl = 0;
      let lx = 0;
      let lt = 0;
      let v = 0;
      let id = 0;
      el.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest && e.target.closest('button, input, select')) return;
        down = true;
        moved = false;
        sx = e.clientX;
        sl = el.scrollLeft;
        lx = e.clientX;
        lt = performance.now();
        v = 0;
        w.cancelAnimationFrame(id);
      });
      w.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
        if (!moved) return;
        el.scrollLeft = sl - dx;
        const now = performance.now();
        v = (e.clientX - lx) / Math.max(1, now - lt);
        lx = e.clientX;
        lt = now;
      });
      w.addEventListener('pointerup', () => {
        if (!down) return;
        down = false;
        el.classList.remove('is-dragging');
        let vel = -v * 18;
        const glide = () => { if (Math.abs(vel) < 0.4) return; el.scrollLeft += vel; vel *= 0.93; id = raf(glide); };
        if (moved) glide();
      });
      el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });
  };

  /* muted reels: at most three play at once, only while they are on screen */
  const vidSeen = new Set();
  const syncVideos = () => {
    let playing = 0;
    $$('[data-amx-video] video').forEach((v) => {
      if (vidSeen.has(v) && playing < 3) {
        playing += 1;
        if (v.paused) {
          if (v.preload === 'none') v.preload = 'metadata';
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        }
      } else if (!v.paused) v.pause();
    });
  };
  const videoIO = IO && !reduce ? new IntersectionObserver((en) => {
    en.forEach((x) => { if (x.isIntersecting) vidSeen.add(x.target); else vidSeen.delete(x.target); });
    syncVideos();
  }, { threshold: 0.5 }) : null;
  const initVideos = (root) => {
    $$('[data-amx-video] video', root).forEach((v) => {
      if (v.__amxV) return;
      v.__amxV = true;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      if (videoIO) videoIO.observe(v);
    });
  };

  /* magnetic buttons */
  const initMagnetic = (root) => {
    if (!fine || reduce) return;
    $$('[data-amx-magnetic]', root).forEach((el) => {
      if (el.__amxMag) return;
      el.__amxMag = true;
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        el.style.transform = 'translate3d(' + ((e.clientX - (r.left + r.width / 2)) * 0.22).toFixed(1) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * 0.3).toFixed(1) + 'px,0)';
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  };

  /* label cursor: shows View, Shop or Drag over the things you can act on */
  const initCursor = () => {
    if (!fine || reduce) return;
    const cur = d.querySelector('.amx-cursor');
    if (!cur) return;
    const label = cur.querySelector('.amx-cursor__label');
    let tx = 0;
    let ty = 0;
    let x = 0;
    let y = 0;
    let running = false;
    let first = true;
    const loop = () => {
      x = lerp(x, tx, 0.22);
      y = lerp(y, ty, 0.22);
      cur.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      if (Math.abs(tx - x) > 0.3 || Math.abs(ty - y) > 0.3) raf(loop); else running = false;
    };
    d.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      tx = e.clientX;
      ty = e.clientY;
      if (first) { x = tx; y = ty; first = false; }
      if (!running) { running = true; raf(loop); }
    }, { passive: true });
    d.addEventListener('pointerover', (e) => {
      const t = e.target && e.target.closest ? e.target.closest('[data-cursor]') : null;
      if (t) { if (label) label.textContent = t.getAttribute('data-cursor'); cur.classList.add('is-on'); } else cur.classList.remove('is-on');
    }, { passive: true });
    d.addEventListener('pointerdown', () => cur.classList.add('is-down'), { passive: true });
    d.addEventListener('pointerup', () => cur.classList.remove('is-down'), { passive: true });
    w.addEventListener('scroll', () => cur.classList.remove('is-on'), { passive: true });
    d.documentElement.addEventListener('mouseleave', () => cur.classList.remove('is-on'));
  };

  const init = (root) => {
    initReveal(root);
    initHero(root);
    initHScroll(root);
    initScenes(root);
    initMarquee(root);
    initCards(root);
    initPreview(root);
    initCraft(root);
    initDrag(root);
    initVideos(root);
    initMagnetic(root);
    measure();
    kick();
  };
  const boot = () => {
    init(d);
    initCursor();
    lift();
    let rt = 0;
    const re = () => { clearTimeout(rt); rt = setTimeout(() => { measure(); kick(); }, 100); };
    if ('ResizeObserver' in w) new ResizeObserver(re).observe(d.body);
    w.addEventListener('resize', re);
    w.addEventListener('load', re);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(re);
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', (e) => init(e.target));
})();
